import {profileTypes} from "@/setup/profiles/ProfileUtils";
import {beef} from "@/store/Services";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let initializedTiktokProfiles = false;
let inflightRequest = false;

export default {
    namespaced: true,

    state: {
        tiktokLoginStatus: {
            loggedIn: false, // is the user currently logged in through Tiktok?
            loginInvalidated: false // has the user's Tiktok login been invalidated?
        },
        tiktokLoggedInAs: null,

        managedTiktokProfiles: []
    },

    mutations: {
        setTiktokLoginStatus: (state, value) => state.tiktokLoginStatus = value,
        setTiktokLoggedInAs: (state, value) => state.tiktokLoggedInAs = value,
        setManagedTiktokProfiles: (state, value) => state.managedTiktokProfiles = value
    },

    actions: {
        async initializeManagedTiktokProfiles({commit, state}, forceRefresh) {
            if (inflightRequest) return;

            try {
                inflightRequest = true;
                forceRefresh = !!forceRefresh;
                if (!forceRefresh && initializedTiktokProfiles) return;
                const response = await beef.get("/api/online-profile/tiktok/list");
                if (response.status === 200) {
                    initializedTiktokProfiles = true;
                    response.data?.forEach(tiktok => {
                        tiktok.type = profileTypes.tikTok;
                    });
                    commit('setManagedTiktokProfiles', response.data);
                }
            } finally {
                inflightRequest = false;
            }

        }
    }
};
